import React, { type ReactElement } from 'react'
import { Panel } from './Panel'
import type { PanelProps } from './types'

export const Panels: React.FC<{
  children: ReactElement<PanelProps>[]
  className?: string
}> = ({ children, className }) => {
  const totalPanels = React.Children.count(children)

  return (
    <div className={className}>
      {React.Children.map(children, (child, idx) => {
        if (!React.isValidElement(child) || child.type !== Panel) {
          throw new Error('<Tabs.Panels> only accepts <Tabs.Panel> as children')
        }
        return React.cloneElement(child, {
          index: idx,
          hasNextPanel: idx < totalPanels - 1,
        })
      })}
    </div>
  )
}
